function setValue(input) {
    const value = ((input.value - input.min) / (input.max - input.min)) * 100;
    input.style.setProperty('--value', `${value}%`);
    input.setAttribute('data-value', input.value);
}

function onMaxChange(mutations) {
    mutations.forEach((mutation) => {
        if (mutation.attributeName === 'max') {
            setValue(mutation.target);
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    const rangeInputs = document.querySelectorAll('.input-range');
    rangeInputs.forEach((input) => {
        setValue(input);
        input.addEventListener('input', (event) => setValue(event.target));
        const observer = new MutationObserver(onMaxChange);
        observer.observe(input, { attributes: true });
    });
});
